import { Navigate, Route, Routes } from 'react-router-dom';
import { PlayerBar } from './components/PlayerBar.js';
import { Loading } from './components/ui.js';
import { useAuth } from './lib/auth.js';
import { FeedbackPage } from './pages/FeedbackPage.js';
import { GoalsPage } from './pages/GoalsPage.js';
import { JourneyEditorPage } from './pages/JourneyEditorPage.js';
import { JourneysPage } from './pages/JourneysPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { SubJourneyPage } from './pages/SubJourneyPage.js';
import { UsersPage } from './pages/UsersPage.js';
import { WaitlistPage } from './pages/WaitlistPage.js';

export function App() {
  const { admin, ready } = useAuth();

  // Hold the first paint until the silent session check settles, so a signed-in admin
  // never sees the login screen flash on refresh.
  if (!ready) return <Loading />;
  if (!admin) return <LoginPage />;

  return (
    <>
      <Routes>
        <Route path="/journeys" element={<JourneysPage />} />
        <Route path="/journeys/:id" element={<JourneyEditorPage />} />
        <Route path="/journeys/:id/sub-journeys/:subJourneyId" element={<SubJourneyPage />} />
        <Route path="/goals" element={<GoalsPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="*" element={<Navigate to="/journeys" replace />} />
      </Routes>
      {/* Docked, so it survives navigating between journeys while something is playing. */}
      <PlayerBar />
    </>
  );
}
